import { useMemo } from "react";
import { AgGrid, AgGridReact } from "@jsq/ds/core";
import { RoleCell } from "~/pages/UserAndRoles/WorkspacesPage/WorkspaceDetailsDrawer/components/WorkspaceUserTable/CellComponents";
import {
  AccessTypeComponent,
  DashboardCell,
  LoginCell,
  StatusComponent,
} from "./CellComponents";

export type AgGridArgs = {
  domLayout?: AgGrid.GridOptions["domLayout"];
  paginationPageSizeSelector?: number[];
  paginationPageSize?: number;
  FinalElement?: ({ value }: AgGridReact.CustomCellRendererProps) => JSX.Element;
  finalColumnText?: string;
  cellRendererParams?: Record<string, unknown>;
  showAccessVia?: boolean;
};
export const useWorkspaceTableAgGridOptions = (args?: AgGridArgs) => {
  const { FinalElement, finalColumnText, cellRendererParams, showAccessVia } = args || {};
  const colDefs: AgGridReact.AgGridReactProps["columnDefs"] = useMemo(() => {
    return [
      {
        field: "arenaName",
        filter: "agTextColumnFilter",
        headerName: "Workspace name",
        cellRenderer: DashboardCell,
      },
      {
        field: "arenaId",
        filter: "agNumberColumnFilter",
        headerName: "Arena ID",
        cellRenderer: DashboardCell,
      },
      {
        field: "roleGroupName",
        filter: "agTextColumnFilter",
        headerName: "Role",
        cellRenderer: RoleCell,
      },
      {
        field: "arenaDomain",
        headerName: "Domain",
        cellRenderer: DashboardCell,
        filter: "agTextColumnFilter",
      },
      {
        field: "active",
        headerName: "Status",
        cellRenderer: StatusComponent,
      },
      { field: "accessType", headerName: "Access type", cellRenderer: AccessTypeComponent },
      ...(showAccessVia
        ? [
            {
              field: "accessVia",
              headerName: "Access via",
              cellRenderer: DashboardCell,
              filter: "agSetColumnFilter",
              filterParams: { values: ["Direct", "All arena"] },
            },
          ]
        : []),
      { field: "endDate", headerName: "Expiration", cellRenderer: DashboardCell },
      {
        field: "lastAccess",
        headerName: "Last access",
        cellRenderer: DashboardCell,
        width: 220,
      },
      {
        field: "login",
        headerName: finalColumnText ?? "Login",
        cellRenderer: FinalElement ?? LoginCell,
        ...(cellRendererParams && { cellRendererParams }),
      },
    ];
  }, [FinalElement, finalColumnText, cellRendererParams, showAccessVia]);

  return { colDefs };
};
